exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SliderPage .fa-folder{color:#00adff}.SliderPage .ant-tree-node-selected .fa-folder{color:#fff}.SliderPage .video_btn{width:40px;height:40px;border-radius:50%;background:#00adff;z-index:999;bottom:60px;right:40px;position:absolute;color:#fff;display:flex;align-items:center;justify-content:center}.SliderPage .folders .qbm-accordion-content{height:calc(100vh - 275px)!important}.SliderPage .folders .qbm-accordion-content__item{border:none!important;display:flex}.SliderPage .folders .qbm-accordion-content__item.child i{margin-left:40px}.SliderPage .folders .qbm-accordion-content__item i{color:#00adff;font-size:26px;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Sliders/style.scss
// module id = 5264
// module chunks = 0